const SECRET_KEY = process.env.REACT_APP_SECRET_KEY || 'default_secret_key';
console.log("SECRET_KEY in Netlify:", SECRET_KEY);

// Convert text to ArrayBuffer and vice versa
const textToArrayBuffer = (text) => new TextEncoder().encode(text);
const arrayBufferToText = (buffer) => new TextDecoder().decode(buffer);

// Generate the key for decryption
const getKey = async () => {
    if (typeof window === 'undefined' || !window.crypto) {
        throw new Error("Crypto API is not available in this environment");
    }

    const keyMaterial = await window.crypto.subtle.importKey(
        "raw",
        textToArrayBuffer(SECRET_KEY),
        { name: "PBKDF2" },
        false,
        ["deriveKey"]
    );

    return window.crypto.subtle.deriveKey(
        {
            name: "PBKDF2",
            salt: textToArrayBuffer("static_salt"),
            iterations: 100000,
            hash: "SHA-256",
        },
        keyMaterial,
        { name: "AES-GCM", length: 256 },
        true,
        ["decrypt"]
    );
};

// Decrypt Student ID
export const decryptStudentId = async (encryptedId) => {
    try {
        if (!encryptedId) throw new Error("No encrypted ID provided");

        console.log("Encrypted ID (Raw):", encryptedId);

        // Decode from URL encoding
        const decodedId = decodeURIComponent(encryptedId);
        console.log("Decoded Encrypted ID:", decodedId);

        let decodedData;
        try {
            decodedData = JSON.parse(atob(decodedId)); // Base64 decode
        } catch (err) {
            console.error("Base64 Decoding Failed:", err.message);
            throw new Error("Decryption failed: Invalid encoding format.");
        }

        // Extract IV and encrypted data
        const iv = new Uint8Array(decodedData.iv);
        const encryptedData = new Uint8Array(decodedData.data);

        console.log("IV Length:", iv.length);
        console.log("Encrypted Data Length:", encryptedData.length);

        // Ensure IV is exactly 12 bytes (AES-GCM requirement)
        if (iv.length !== 12) {
            throw new Error(`Invalid IV length: ${iv.length}, expected 12 bytes.`);
        }

        const key = await getKey();

        // Perform decryption
        const decrypted = await window.crypto.subtle.decrypt(
            { name: "AES-GCM", iv },
            key,
            encryptedData
        );

        return arrayBufferToText(decrypted);
    } catch (error) {
        console.error("Full Decryption Error:", error);
        return "Invalid ID";
    }
};
